import React from 'react';
import BackButton from './BackButton';

function FAQPage({ setPage, user, handleLogout }) {
  const faqs = [
    {
      question: "What is PatTrak?",
      answer: "PatTrak is an AI-powered patent search and analysis platform with 1.45 million USPTO patents. Features include AI semantic search, patent analyses at three depth levels, prior art reports, company intelligence, citation network visualization, and patent application tracking."
    },
    {
      question: "How do I search for patents?",
      answer: "Use the search bar with four search types: Patent Number (direct lookup), Company (find all patents by assignee), Inventor (find patents by inventor name), or AI Search (describe what you're looking for in plain English and our AI finds relevant patents)."
    },
    {
      question: "What are the different analysis levels?",
      answer: "Quick Analysis provides a brief overview. Standard Analysis gives detailed technical breakdown with claims analysis. Deep Analysis offers comprehensive evaluation including prior art context and commercial potential. Higher tiers unlock more analysis options."
    },
    {
      question: "What are Prior Art Reports?",
      answer: "Prior Art Reports are attorney-grade PDF documents that analyze a patent against potential prior art. They include jurisdiction-specific legal frameworks (US, UK/EPO Hybrid, EPO Strict) and formal Problem-Solution Approach formatting. Available to Pro subscribers."
    },
    {
      question: "How do I save patents and searches?",
      answer: "Click the bookmark icon on any patent card to save it. Click 'Save This Search' above results to save a search. Access saved items from the side menu. Free users can save 10 patents and 5 searches; Premium users get 100/50; Pro users get unlimited."
    },
    {
      question: "What is Company Intelligence?",
      answer: "Company Intelligence analyzes any company's patent portfolio showing their granted patents, pending applications, technology focus areas, and top inventors. Great for competitive analysis and understanding market landscapes."
    },
    {
      question: "What is Citation Network?",
      answer: "Citation Network visualizes how patents cite each other, helping you understand technology evolution and find related patents. Available to Premium and Pro subscribers."
    },
    {
      question: "What's included in each subscription tier?",
      answer: "Free: 10 AI searches/day, 5 quick analyses, basic features. Premium (£10/mo): 50 AI searches, standard analyses, citations, full landscape charts. Pro (£25/mo): Unlimited searches and analyses, prior art reports, deep analysis. See our Pricing page for full details."
    }
  ];

  return (
    <div style={{ minHeight: '100vh', background: 'white' }}>
      <header style={{ padding: '16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
          <BackButton onClick={() => setPage('search')} />
          <img
            src="/logo.svg"
            alt="PatTrak Logo"
            style={{
              height: '32px',
              cursor: 'pointer'
            }}
            onClick={() => setPage('search')}
          />
        </div>
        <div style={{ display: 'flex', gap: '16px' }}>
          {user ? (
            <button onClick={handleLogout} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#1d2934' }}>
              Logout
            </button>
          ) : (
            <>
              <button onClick={() => setPage('login')} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#1d2934' }}>Log in</button>
              <button onClick={() => setPage('register')} style={{ background: '#53dafc', color: 'white', padding: '8px 16px', borderRadius: '4px', border: 'none', cursor: 'pointer' }}>Sign up free</button>
            </>
          )}
        </div>
      </header>

      <main style={{ maxWidth: '800px', margin: '80px auto', padding: '0 16px' }}>
        <h1 style={{ fontSize: '36px', fontWeight: 'bold', color: '#1d2934', marginBottom: '16px' }}>
          Frequently Asked Questions
        </h1>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
          {faqs.map((faq, index) => (
            <div key={index} style={{ borderBottom: '1px solid #e0e0e0', paddingBottom: '24px' }}>
              <h3 style={{ fontSize: '20px', fontWeight: '600', color: '#1d2934', marginBottom: '8px' }}>
                {faq.question}
              </h3>
              <p style={{ fontSize: '16px', color: '#474f58', lineHeight: '1.6' }}>
                {faq.answer}
              </p>
            </div>
          ))}
        </div>
      </main>

      <footer style={{
        padding: '32px 16px',
        textAlign: 'center',
        borderTop: '1px solid #e0e0e0',
        marginTop: '80px',
        color: '#5e778a',
        fontSize: '14px'
      }}>
        By using Patent Tracker, you agree to our{' '}
        <a href="#" style={{ color: '#53dafc', textDecoration: 'none' }}>Terms</a>
        {' '}and have read our{' '}
        <a href="#" style={{ color: '#53dafc', textDecoration: 'none' }}>Privacy Policy</a>
        . See{' '}
        <a href="#" style={{ color: '#53dafc', textDecoration: 'none' }}>Cookie Preferences</a>.
      </footer>
    </div>
  );
}

export default FAQPage;
